import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ARTICLES, ARTICLE_SLUGS } from '@/pages/articles/data';

export default function PillarArticlesSection() {
  const { t } = useTranslation('common');
  const location = useLocation();
  const lang = location.pathname.split('/')[1] || 'en';
  const currentLang = ['en', 'pt', 'de'].includes(lang) ? lang : 'en';

  const icons = [
    'ri-article-line',
    'ri-truck-line',
    'ri-building-2-line',
    'ri-shield-check-line',
    'ri-coupon-line',
    'ri-percent-line',
    'ri-image-line',
    'ri-compass-3-line',
    'ri-ship-2-line',
    'ri-scales-3-line',
  ];

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
            {t('pillar.h2')}
          </h2>
          <p className="text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            {t('pillar.desc')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
          {ARTICLE_SLUGS.map((slug, i) => {
            const article = ARTICLES[slug]?.[currentLang as 'en' | 'pt' | 'de'];
            if (!article) return null;
            return (
              <a
                key={slug}
                href={`/${currentLang}/articles/${slug}`}
                className="group block p-6 bg-background-50 rounded-xl border border-background-200 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
              >
                <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4">
                  <i className={`${icons[i % icons.length]} text-lg`} />
                </div>
                <h3 className="font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {article.cardTitle}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{article.cardDesc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  {t('cta.readMore')}
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}